import React, { useState, useEffect } from "react";
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import IconButton from 'components/common/IconButton';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PermissionSetupTable from "components/partials/permissions/permission-setup/PermissionSetupTable";
import PermissionSetupModal from "./PermissionSetupModal";
import { searchPermissionSetups } from "services/permissions/permissionSetupServices";
import { BaseTableRQ } from "components/pages/stock-location/models/BaseTable"

export default function PermissionSetupList() {
    const [permissionSetups, setPermissionSetups] = useState([]);
    const [total, setTotal] = useState(0);
    const [paging, setPaging] = useState(new BaseTableRQ(1, 100));
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);

    useEffect(() => {
        loadPermissionSetups(paging);
    }, [])

    const loadPermissionSetups = (pagingRq) => {
        searchPermissionSetups(pagingRq).then(res => {
            if (res) {
                setPermissionSetups(res.items);
                setTotal(res.total);
            }
        })
            .catch(err => {
                console.log(err);
            });

        setPaging(pagingRq);
    }

    const gotoPage = (index) => {
        index += 1;
        if (index <= 0) return;
        paging.pageNum = index;
        loadPermissionSetups(paging);
    }

    const nextPage = () => {
        const page = paging.pageNum + 1;
        if (page > Math.ceil(total / paging.pageSize)) return;
        paging.pageNum = page;
        loadPermissionSetups(paging);
    }

    const previousPage = () => {
        const page = paging.pageNum - 1;
        if (page <= 0) return;
        paging.pageNum = page;
        loadPermissionSetups(paging);
    }

    const handleOpenNew = () => {
        setDataModal(null);
        setIsModal(true);
    }

    const handleCloseModal = () => {
        setIsModal(false);
        setDataModal(null);
    }

    const handleSubmitModal = () => {
        handleCloseModal();
        loadPermissionSetups(paging);
    }

    return (
        <>
            <PageHeader
                title="Permission Setup List"
                description={`Manage and view all available Permission Setup from this page.`}
                className="mb-3"
            ></PageHeader>
            <Card>
                <FalconCardHeader
                    title="Permission Setup"
                    light
                    titleTag="h6"
                    endEl={
                        <IconButton
                            variant="falcon-default"
                            size="sm"
                            icon="plus"
                            transform="shrink-3"
                            onClick={handleOpenNew}
                        >
                            <span className="d-none d-sm-inline-block ms-1">New</span>
                        </IconButton>
                    }
                />
                <Card.Body style={{ padding: '10px' }}>
                    <PermissionSetupTable
                        data={permissionSetups}
                        paging={paging}
                        total={total}
                        nextPage={nextPage}
                        previousPage={previousPage}
                        gotoPage={gotoPage}
                        handleClickRow={(e, row) => {
                            if (row) {
                                setDataModal(row.original);
                                setIsModal(true);
                            }
                        }}
                    />
                </Card.Body>
            </Card>
            <PermissionSetupModal
                isShow={isModal}
                handleClose={handleCloseModal}
                data={dataModal}
                handleSubmit={handleSubmitModal}
            />
        </>)
}